import type { HsVector3 } from '../../math-new/objects/vector3.class';
import type { HsEmitter } from './emitter.interface';
import { HsSphere } from '../../math-new/shapes/sphere.class';

export class HsSphereEmitter implements HsEmitter {
  public shape: HsSphere;

  constructor(x: number, y: number, z: number, radius: number) {
    this.shape = new HsSphere(x, y, z, radius);
  }

  public setCenter(x: number, y: number, z: number): void {
    this.shape.center.set(x, y, z);
  }

  public getRandomPosition(target: HsVector3): HsVector3 {
    return target.setRandom().multiplyByScalar(this.shape.radius).add(this.shape.center);
  }
}
